function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7 0C10.8598 0 14 3.1402 14 7C14 10.8598 10.8598 14 7 14C3.1402 14 0 10.8598 0 7C0 3.1402 3.1402 0 7 0ZM7 1.05C3.7191 1.05 1.05 3.7191 1.05 7C1.05 8.442 1.5659 9.7664 2.4227 10.7975L10.8101 2.4332C9.77691 1.5701 8.4483 1.05 7 1.05ZM7 12.95C10.2809 12.95 12.95 10.2809 12.95 7C12.95 5.5839 12.4523 4.2812 11.6228 3.2585L3.24591 11.613C4.27071 12.4488 5.5776 12.95 7 12.95Z",
  fill: "#899296"
});

var SvgVector = function SvgVector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Vector.800f6bf1.svg";
export { ForwardRef as ReactComponent };